import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import _ from 'lodash';

const DetailSection = ({ content, type }) => {
  return (
    <section className="row justify-content-between">
      <div className="col-15 col-md-5 col-lg-5">
        <div className="brand-detail-brand-image">
          <Image
            src={`/image/${type}/${content.id}.jpg`}
            layout="responsive"
            width="280"
            height="280"
          />
        </div>

      </div>
      <div className="col-15 col-md-9 col-lg-9">
        <div className="row mb-30 mt-20">
          <div className="col">
            <h3 className="h1">{content.title}</h3>
          </div>
        </div>
        <div className="row mb-20">
          <div className="col-15">
            {
              _.map(content.texts, (text) => <p className="text-justify lighter">{text}</p>)
            }
          </div>
        </div>
      </div>
    </section>
  );
};

DetailSection.propTypes = {
  content: PropTypes.object,
  type: PropTypes.string,
};

export default DetailSection;
